module.exports = __webpack_public_path__ + "assets/media/LOGO.79483953.png";